import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ConfigurationService, HttpBaseService, LocalizationService, NotifyService } from '@app/core';
import { ApiControllerEnum } from '@app/shared/common/enums';
import { UserProfileInfo } from '@app/vinter/models/user-profile-list-item';
import { Observable, filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TopbarService extends HttpBaseService {
  public isUserProfilePage: boolean = false;

  constructor(private http: HttpClient
    , private notifyServ: NotifyService
    , private localizationService: LocalizationService
    , private configService: ConfigurationService) {
    super(http, ApiControllerEnum.User, notifyServ, localizationService, configService);

  }
  getUserImageUrl(): Observable<UserProfileInfo>{
    return this.getWithoutSpinner("GetUserImageUrl");
  }


}
